const MicrosoftIcon = () => {
  return (
    <svg
      width={26}
      height={20}
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9455 18.9319C15.2629 18.3459 18.0029 17.861 18.0344 17.8543L18.0916 17.8422L14.9596 14.1168C13.237 12.0678 11.8277 10.3835 11.8277 10.3737C11.8277 10.3554 15.0617 1.44958 15.0799 1.41787C15.0859 1.4073 17.2868 5.207 20.4149 10.6286C23.3434 15.7044 25.7579 19.8895 25.7803 19.9287L25.8211 20L15.8675 19.9987L5.91383 19.9974L11.9455 18.9319ZM0 17.7959C0 17.7906 1.47577 15.2288 3.27948 12.1029L6.55896 6.41955L10.3808 3.21224C12.4828 1.44822 14.2083 0.00277719 14.2153 6.85908e-05C14.2222 -0.00249457 14.1945 0.067101 14.1538 0.154799C14.1131 0.242497 12.2456 4.24809 10.0038 9.05611L5.92784 17.798L2.96392 17.8017C1.33376 17.8037 0 17.8011 0 17.7959Z"
        fill="#0089D6"
      />
    </svg>
  );
};

export default MicrosoftIcon;
